
    import { Component } from 'vue-property-decorator';
    import { mixins } from 'vue-class-component';

    import IsExclusiveBlockMixin from '@ve/components/hotel/isExclusiveBlock/common/IsExclusiveBlockMixin';

    @Component({})
    export default class isExclusiveBlock extends mixins(IsExclusiveBlockMixin) {}
